import { render, staticRenderFns } from "./No14.vue?vue&type=template&id=207c786c&scoped=true"
import script from "./No14.vue?vue&type=script&lang=js"
export * from "./No14.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207c786c",
  null
  
)

export default component.exports